module.exports = __webpack_public_path__ + "static/media/boldy.0578d5c0.png";